export default "__VITE_ASSET__CzXi$V6d__"